import { forwardRef } from "react"
import { Day } from "@gogoro/go-design"
import { dateToUnixTimestamp, unixTimestampToDate } from "utils/formatTime"

import { DateRangePickerProps } from "./DateRangePickerProps"
import GenericDateRangePicker from "./GenericDateRangePicker"

const formatInput = (unixTimestamp: number | null) => {
  if (!unixTimestamp) {
    return null
  }
  return unixTimestampToDate(unixTimestamp)
}

const formatOutput = (date: Day) => {
  return dateToUnixTimestamp(date)
}

const DateRangePicker = ({ value, name, onChange, testId, ...restProps }: DateRangePickerProps<number>, ref: any) => {
  return (
    <div data-testid={`date-range-picker-${name}`}>
      <GenericDateRangePicker<number>
        name={name}
        onChange={onChange}
        formatOutput={formatOutput}
        formatInput={formatInput}
        testId={testId}
        value={value}
        myRef={ref}
        {...restProps}
      />
    </div>
  )
}

export default forwardRef(DateRangePicker)
